<template>
<div class="container mar-t-70 mb20 resp70">
  <div class="flexrow_green mb50" >
    <div class="subheader_flex">
      <h1 class="nomargin redhigh">Add Member</h1>
    </div>
    <div class="flexcircle">
      <router-link to="/members"  class="btn btn-vermilion">Back</router-link>
    </div>
  </div>
  <div class="row">
    <div class="container ">
      <div class="col-lg-8 offset-lg-2  bg-white bx-shaw pad40">

          <ValidationObserver  ref="observer" v-slot="{ invalid }"  >
        <form class="mar-t-30" @submit.prevent="submitpage()">
          <div class="form-group">
              <span class="loginerror">{{errorreport}}</span>
          </div>
          <div class="form-group">
            <ValidationProvider rules="required" name="First Name" v-slot="{ errors }">
            <input type="text" class="form-control" placeholder="First Name" v-model = "member.fname" >
            <span class="loginerror">{{ errors[0] }}</span>
          </ValidationProvider>
          </div>
          <div class="form-group">
            <input type="text" class="form-control" placeholder="Last Name" v-model = "member.lname" >
          </div>
          <div class="form-group">
            <ValidationProvider rules="required" name="Email" v-slot="{ errors }">
            <input type="email" class="form-control"  placeholder="Email" v-model = "member.email" v-on:blur="checkemail(member.email)" >
            <span class="loginerror">{{ errors[0] }}</span>
          </ValidationProvider>
          </div>
          <div class="form-group">
            <ValidationProvider :rules="{required: true, regex: /^[6-9]\d{9}$/}" name="Phone Number" v-slot="{ errors }">
            <input type="text" class="form-control" placeholder="Phone Number" v-model="member.phone_no" >
            <span class="loginerror">{{ errors[0] }}</span>
          </ValidationProvider>
          </div>
          <div class="form-group">
            <!-- <label for="">Address</label> -->
            <textarea type="text" class="form-control" placeholder="Address" v-model="member.address" ></textarea>
          </div>
                          <div class="form-group">
            <ValidationProvider :rules="{required: true, regex: /^[ A-Za-z0-9_@-]*$/}" name="User Id" v-slot="{ errors }">
            <input type="text" class="form-control" placeholder="User Id" v-model = "member.username" v-on:blur="checkusername(member.username)" >
            <span class="loginerror">{{ errors[0] }}</span>
          </ValidationProvider>
          </div>
          <div class="form-group">
            <ValidationProvider rules="required|min:6" name="Password" v-slot="{ errors }">
            <input type="password" class="form-control" placeholder="Password" v-model = "member.password" >
            <span class="loginerror">{{ errors[0] }}</span>
          </ValidationProvider>
          </div>
          <h3>Site Information:</h3>
          <div class="form-group">
            <ValidationProvider rules="required" name="Store Name" v-slot="{ errors }">
            <input type="text" class="form-control" placeholder="Store Name" v-model = "member.sname" v-on:blur="checkuser_store(member.sname)">
            <span class="loginerror" v-if=" errorreports == ''">{{ errors[0] }}</span>
            <span class="loginerror" v-if=" errorreports !== ''">{{ errorreports }}</span>
          </ValidationProvider>
        </div>
        <div class="form-group">
          <ValidationProvider rules="required" name="Domain Name" v-slot="{ errors }">
          <input type="text" class="form-control" placeholder="Domain Name" v-model = "member.surl" v-on:blur="checkurl(member.surl)" v-on:keyup="checkurl(member.surl)">
          <span class="loginerror" v-if=" errorreportu == ''">{{ errors[0] }}</span>
          <span class="loginerror" v-if=" errorreportu !== ''">{{ errorreportu }}</span>
        </ValidationProvider>
      </div>

        <!-- <div class="form-group">
        <ValidationProvider rules="required" name="Store Pincode" v-slot="{ errors }">
        <input type="text" class="form-control"  placeholder="Store Pincode" v-model = "member.store_pincode" >
        <span class="loginerror">{{ errors[0] }}</span>
      </ValidationProvider>
      </div>
        <div class="form-group">
          <label>Store Address</label>
          <ckeditor :editor="editor"   v-model="member.saddress"   name="content" data-vv-as="Content"></ckeditor>
      </div>
      <div class="form-group">
        <ValidationProvider rules="required" name="Email" v-slot="{ errors }">
        <input type="email" class="form-control"  placeholder="Site Email" v-model = "member.semail" >
        <span class="loginerror">{{ errors[0] }}</span>
      </ValidationProvider>
      </div>
      <div class="form-group">
        <ValidationProvider :rules="{regex: /^[6-9]\d{9}$/}" name="Store Phone Number" v-slot="{ errors }">
        <input type="text" class="form-control" placeholder="Site Phone Number" v-model="member.sphone_no" >
        <span class="loginerror">{{ errors[0] }}</span>
      </ValidationProvider>
      </div>
      <div class="form-group">
        <input type="radio" id="shiplite" name="Ship Lite" value="Shiplite" v-model = "member.shippingtype">
  <label for="razorpay">Ship Lite</label>
  <input type="radio" id="shiprocket" name="Ship Rocket" value="shiprocket" v-model = "member.shippingtype">
  <label for="paytm">Ship Rocket</label>
      </div>
      <div class="form-group">
        <input type="radio" id="razorpay" name="Razorpay" value="razorpay" v-model = "member.payoption">
  <label for="razorpay">Razorpay</label>
  <input type="radio" id="paytm" name="Paytm" value="paytm" v-model = "member.payoption">
  <label for="paytm">Paytm</label>
  <input type="radio" id="payumoney" name="Pay U Money" value="payumoney" v-model = "member.payoption">
  <label for="payumoney">Pay U Money</label>
      </div>
          <div class="form-group" v-if="member.payoption">
            <ValidationProvider rules="required" name="Access Key Id" v-slot="{ errors }">
            <input type="text" class="form-control" placeholder="Access Key Id" v-model = "member.accessid" >
            <span class="loginerror">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
          <div class="form-group" v-if="member.payoption">
            <ValidationProvider rules="required" name="Access Key" v-slot="{ errors }">
            <input type="text" class="form-control" placeholder="Access Key" v-model = "member.accesskey" >
            <span class="loginerror">{{ errors[0] }}</span>
          </ValidationProvider>
        </div> -->
      <!-- <div class="col-12 mb20">
        <div class="flexrow ">
          <div class="subheader_flex">
            <h2>Store Logo </h2>
          </div>
          <div class="flexcircle">
            <div class="upload-btn-wrapper">
              <button class="btn btn-green">Upload Logo</button>
              <input type="file" id="files" ref="files"  v-on:change="handleFilesUpload($event)" />
            </div>
          </div>
        </div>
        <div class="clearfix col-12 filebox ">
          <div class="uploadmess text-center" v-if="files.length === 0">
            Please click Upload Logo button to add Logo
          </div>
          <div class="file-listing clearfix" v-for="(file, key) in files" v-bind:key ="key">
            <div class="flexrow fixeddim">
              <img :ref="'image'" class="img-fluid"/>
              <div class="file_btn flexcircle">
                <button type="button" v-on:click="removeFile( key )" class="btn smallbtn btn-vermilion" name="button">x</button>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    <div class="text-center mb0">
      <button :disabled="isdisabled" type="submit" class="submit-button">Submit</button>

    </div>
        </form>
          </ValidationObserver>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
export default {
  name: 'addmember',
  data () {
    return {
      isdisabled: false,
      storename: '',
      member: {
        fname: '',
        lname: '',
        email: '',
        phone_no: '',
        address: '',
        username: '',
        password: '',
        sname: '',
        surl: ''
        // saddress: '',
        // semail: '',
        // sphone_no: '',
        // store_pincode: '',
        // payoption: '',
        // payoption1 : '',
        // payoption2 : '',
        // payoption3: '',
        // accessid : '',
        // accesskey: '',
        // shippingtype: ''
      },
      editor: ClassicEditor,
      files: [],
      error: false,
      errorreport: '',
      errorreports: '',
      errorreportu: ''
    }
  },
  methods: {
    checkusername (id) {
      if (id !== '') {
        this.$http.get('/register/checkusername/' + id).then((res) => {
          if (res.data.success === true) {
            this.member.username = ''
            this.error = true
            this.errorreport = res.data.message
          } else {
              this.error = false
          }
        })
      }
    },
    checkuser_store () {
      if (this.member.sname !== '') {
        this.$http.post('/register/checkuserstore/' , {store_name: this.member.sname}).then((res) => {
          if (res.data.success === true) {
            this.member.sname = ''
            this.error = true
            this.errorreports = res.data.message
          } else {
              this.error = false
          }
        })
      }
    },
    checkurl (id) {
      if (id !== '') {
        this.$http.get('/register/checkuserdomain?url=' + id).then((res) => {
          if (res.data.success === true) {
            this.member.surl = ''
            this.error = true
            this.errorreportu = res.data.message
          } else {
              this.error = false
          }
        })
      }
    },
    checkemail (id) {
      if (id !== '') {
        this.$http.get('/register/checkademail/' + id).then((res) => {
          if (res.data.success === true) {
            this.member.email = ''
            this.error = true
            this.errorreport = res.data.message
          } else {
              this.error = false
          }
        })
      }
    },
    handleFilesUpload () {
      // this.files = []
      let uploadedFiles = this.$refs.files.files
      /*
        Adds the uploaded file to the files array
      */
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i])
      }
      for (let i = 0; i < this.files.length; i++) {
        let reader = new FileReader();
       reader.onload = (e) => {
          this.$refs.image[i].src = reader.result;

        };

        reader.readAsDataURL(this.files[i]);
      }
    },
    removeFile (key) {
      this.files.splice(key, 1)
    },

async submitpage () {
  this.vueloaders = true
  const isValid = await this.$refs.observer.validate()
if (isValid) {
  this.isdisabled = true
this.errorreport = ''
  this.$http.post('/register/adminsignup', this.member).then((res) => {
    if (res.data.success === true) {
      // let formData = new FormData()
      // if (this.files.length !== 0) {
      //   for (let j = 0; j < this.files.length; j++) {
      //     let file = this.files[j]
      //     formData.append('files[' + j + ']', file)
      //   }
      //   console.log(this.files)
      //   console.log(formData)
      //   formData.append('storeid', res.data.storeid)
      //   this.$http.put('/register/storelogo', formData, {
      //     headers: {
      //       'Content-Type': 'multipart/form-data'
      //     }
      //   }).then((res1) => {
      //     if (res1.data.success === true) {
      //       this.$router.push('/member_info/' + res.data.adminid)
      //     } else {
      //       console.log(res.data.message)
      //     }
      //   }).catch((err) => {
      //     console.log(err)
      //   })
      // } else {
      //   this.$router.push('/member_info/' + res.data.adminid)
      // }
      this.$router.push('/member_info/' + res.data.adminid)
    }
    this.isdisabled = false
  }).catch((err) => {
    this.isdisabled = false
    console.log(err)
  })
} else {
  console.log('required feilds')
// this.errorreport = "All Feilds Are Required."
}
}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/add-member.vue